import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";
import { Preview } from '../../../../helpers/ui/FileInput'
import apiResponse from '../../../../services/apiResponse'
import moment from 'moment';

import DetailBloc from './Blocs/DetailBloc'

class IndexView extends Component {

    detailBloc = new DetailBloc()

    constructor(props) {
        super(props)
        this.state = {}
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response
                        })
                        //console.log(response)
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }


    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Detail Pencantuman Gelar</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Informasi Detail Pencantuman Gelar
                                    </CardSubtitle>
                                    <hr />

                                     <Row className="mb-3">
                                        <label className="col-md-4">
                                        NIP
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.education_background_employee_nip !== "" ? this.state.detail.education_background_employee_nip : '-'}</>
                                                : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-4">
                                        Nama
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.education_background_employee_full_name !== "" ? this.state.detail.education_background_employee_full_name : '-'}</>
                                                : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-4">
                                        Jenis Pencantuman
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.education_background_isgelar_name !== "" ? this.state.detail.education_background_isgelar_name : '-'}</>
                                                : <Shimmer><div style={{width: 250, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                     <Row className="mb-3">
                                        <label className="col-md-4">
                                        Tingkat Pendidikan
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.education_background_education_name !== "" ? this.state.detail.education_background_education_name : '-'}</>
                                                : <Shimmer><div style={{width: 250, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    

                                     <Row className="mb-3">
                                        <label className="col-md-4">
                                        Rumpun
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.education_group_name !== "" ? this.state.detail.education_group_name : '-'}</>
                                                : <Shimmer><div style={{width: 250, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                     <Row className="mb-3">
                                        <label className="col-md-4">
                                        Jurusan
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.education_background_school_major !== "" ? this.state.detail.education_background_school_major : '-'}</>
                                                : <Shimmer><div style={{width: 250, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                        Tanggal Ijazah
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.education_background_certificate_date !== "" ? this.dateParse(this.state.detail.education_background_certificate_date) : '-'}</>
                                                : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-4">
                                        Tahun Lulus
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.education_background_graduation_year !== "" ? this.state.detail.education_background_graduation_year : '-'}</>
                                                : <Shimmer><div style={{width: 100, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                        Nomor Ijazah
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.education_background_certificate_number !== "" ? this.state.detail.education_background_certificate_number : '-'}</>
                                                : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                        Nama Universitas
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.education_background_school_name !== "" ? this.state.detail.education_background_school_name : '-'}</>
                                                : <Shimmer><div style={{width: 350, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     {/* <Row className="mb-3">
                                        <label className="col-md-4">
                                        Alamat
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.education_background_school_address !== "" ? this.state.detail.education_background_school_address : '-'}</>
                                                : <Shimmer><div style={{width: 450, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row> */}

                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                        Gelar Depan
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.education_background_front_title !== "" ? this.state.detail.education_background_front_title : '-'}</>
                                                : <Shimmer><div style={{width: 150, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                        Gelar Belakang
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.education_background_end_title !== "" ? this.state.detail.education_background_end_title : '-'}</>
                                                : <Shimmer><div style={{width: 150, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                        jabatan yang Membidangi
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.selected_jabatan_membidangi?.position_name !== "" ? this.state.detail.selected_jabatan_membidangi?.position_name : '-'}</>
                                                : <Shimmer><div style={{width: 150, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                        Lokasi Dikeluarkannya Ijazah
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.education_background_ijazah_location !== "" ? this.state.detail.education_background_ijazah_location : '-'}</>
                                                : <Shimmer><div style={{width: 150, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                            File Ijazah & Transkrip Nilai
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {this.state.detail.document_ijazah !== null ?  
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.detail.document_ijazah.documents_path}>
                                                                Download <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                        : '-'}
                                                    </>
                                                :
                                                    <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                            File Akreditasi Program Studi
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {this.state.detail.document_akreditasi !== null ?  
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.detail.document_akreditasi.documents_path}>
                                                                Download <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                        : '-'}
                                                    </>
                                                :
                                                    <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                            File Penyetaraan Ijazah Bagi Lulusan Luar Negeri
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {this.state.detail.document_penyetaraan !== null ?  
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.detail.document_penyetaraan.documents_path}>
                                                                Download <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                        : '-'}
                                                    </>
                                                :
                                                    <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    {
                                        this.state.detail?.education_background_isgelar==1 ?
                                    <>
                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                            SK Tugas Belajar
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {this.state.detail.document_tubel !== null ?  
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.detail.document_tubel.documents_path}>
                                                                Download <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                        : '-'}
                                                    </>
                                                :
                                                <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    </>
                                    :''}
                                    {
                                        this.state.detail?.education_background_isgelar==2 ?
                                    <>
                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                            Surat Izin Belajar
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {this.state.detail.document_izin_belajar !== null ?  
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.detail.document_izin_belajar.documents_path}>
                                                                Download <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                        : '-'}
                                                    </>
                                                :
                                                <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    </>
                                    :''}
                                    {
                                        this.state.detail?.education_background_isgelar==3 ?
                                    <>
                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                            Surat Kronologi
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {this.state.detail.document_kronologi !== null ?  
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.detail.document_kronologi.documents_path}>
                                                                Download <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                        : '-'}
                                                    </>
                                                :
                                                <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    </>
                                    :''}

                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                            Nota Dinas
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {this.state.detail.document_notadinas !== null ?  
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.detail.document_notadinas.documents_path}>
                                                                Download <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                        : '-'}
                                                    </>
                                                :
                                                <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                            SK Pangkat Terakhir
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {this.state.detail.document_s_klastjab !== null ?  
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.detail.document_s_klastjab.documents_path}>
                                                                Download <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                        : '-'}
                                                    </>
                                                :
                                                <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <hr />
                                        
                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                        Nomor Pertek BKN
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.education_background_title_sk_number !== "" ? this.state.detail.education_background_title_sk_number : '-'}</>
                                                : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                        Tanggal Pertek BKN
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.education_background_title_sk_date !== "" ? this.dateParse(this.state.detail.education_background_title_sk_date) : '-'}</>
                                                : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                            File Pertek BKN
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {this.state.detail.document_sk !== null ?  
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.detail.document_sk.documents_path}>
                                                                Download <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                        : '-'}
                                                    </>
                                                :
                                                    <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                            
                                    <hr />
                                   
                                    <Row className="mb-3">
                                        <Col md="3"></Col>
                                        <Col md="8">
                                            <Link to="/kepegawaian/pencantuman_gelar.html" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                    
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);